
import { Alert } from "@portal/BaseComponents/Alert/AntAlert";
import { AlertProps } from "@portal/BaseComponents/Alert/type";
import { Icon } from "@portal/lib/icons/icons";
import { Style } from "@portal/lib/style/style";
import { LOGIN_ERROR_STATUS } from "@portal/types/common";
import { NonUndefined } from "@portal/types/utils";
import React, { memo } from "react";
import { getLoginErrorConfig } from "./predicate";

export const StyledAlert = Style(React.memo(Alert), {
  "&.ant-alert": {
    display: "flex",
    alignItems: "flex-start",
    gap: "var(--space-8)",

    svg: {
      margin: 0,
      marginTop: "var(--space-4)",
    },
  },
});
export type AlertStatus = NonUndefined<AlertProps["type"]>;
interface AlterInfoProps {
  status?: AlertStatus;
}
interface OTPErrorInfoProps {
  status?: LOGIN_ERROR_STATUS;
  onFinish?: () => void;
  onSuccessCallBack?: () => void;
}

type AlertTitle = {
  [key in AlertStatus]: string;
};
type AlertIcon = {
  [key in AlertStatus]: JSX.Element;
};
export type OTPErrorInfoConfig = {
  [key in LOGIN_ERROR_STATUS]: {
    message: string;
    icon: React.ReactNode;
  };
};

const t: AlertTitle = {
  error: "Wrong PIN entered. Try again",
  success:
    "Authentication success. You will be redirected to the customer portal now.",
  info: "We have sent a 6 digits PIN to the email address you entered.",
  warning: "Time out. Generate PIN again to sign in to the customer portal.",
};
const icons: AlertIcon = {
  success: <Icon icon={['far','check-circle']} color="var(--green-6)" />,
  info: <Icon icon={['far','info-circle']} color="var(--geekblue-6)" />,
  warning: (
    <Icon icon={['far','exclamation-circle']} color="var(--geekblue-6)" />
  ),
  error: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
};
export const AlterInfo = memo(function AlterInfo(
  props: Readonly<AlterInfoProps>
) {
  const { status } = props;

  if (!status) return null;

  function getAlertIconStatus(status: AlertStatus) {
    return { icon: icons[status], text: t[status] };
  }

  return (
    <StyledAlert
      type={status}
      icon={getAlertIconStatus(status).icon}
      message={getAlertIconStatus(status).text}
      showIcon
      style={{ width: "100%", order: status === "error" ? 2 : "initial" }}
    />
  );
});

export const OTPErrorInfo = memo(function OTPErrorInfo(
  props: Readonly<OTPErrorInfoProps>
) {
  const { status } = props;

  if (!status) return null;

  const message = getLoginErrorConfig(status).message;
  return (
    <StyledAlert
      type="error"
      icon={getLoginErrorConfig(status).icon}
      message={message}
      showIcon
      style={{ width: "100%", order: 2 }}
      key={status}
    />
  );
});
